import { Injectable, inject } from '@angular/core';
import { LoDialogService } from 'lo-design-system';
import { map, Observable } from 'rxjs';
import { RemoveMemberDialogComponent } from './remove-member-dialog.component';
import {
	RemoveMemberDialogData,
	RemoveMemberDialogResult
} from './remove-member-dialog.model';

@Injectable({ providedIn: 'root' })
export class RemoveMemberDialogService {
	private readonly dialogs = inject(LoDialogService);

	open(
		data: RemoveMemberDialogData,
		opener?: HTMLElement | null
	): Observable<RemoveMemberDialogResult> {
		const ref = this.dialogs.open<
			RemoveMemberDialogComponent,
			RemoveMemberDialogData,
			RemoveMemberDialogResult
		>(RemoveMemberDialogComponent, {
			data,
			opener: opener ?? undefined
		});
		return ref.closed.pipe(map(result => result ?? { confirmed: false }));
	}
}
